
import OrdersBoxMobile from '../components/orders-box-mobile.vue';
import SortPicker from '../components/sort-picker.vue';
import FilledForm from '../form/filled-form.vue';
import Form2 from '../form/form2.vue';
import Report2 from '../report/report2.vue';

export default {
  name: 'v3',
  components: {
    SortPicker,
    Form2,
    FilledForm,
    Report2,
    OrdersBoxMobile
  },
  created() {
    let t = this;

    t.tableScale = localStorage['tableScale'] ? Number(localStorage['tableScale']) : 100;
    t.statusDict = listToDict(t.list.status);

    t.month = new Date().getMonth() + 1;

    t.todayText = t.today.format('yyyy/MM/dd');

    let d = new Date();
    d.setDate(d.getDate() - 2);
    t.startDate = new Date(d.format("yyyy/MM/dd"));
    t.days = 31;
    t.endDate = new Date(
      t.startDate.getFullYear(),
      t.startDate.getMonth(),
      t.startDate.getDate() + 31
    );

    axios.get("employee?role=2").then((res) => {
      if (res.data.status == 1) {
        let items = res.data.options.items;
        t.cleanerDict = listToDict(items);

        let selection = [];

        if (localStorage["selected_cleaner_ids"]) {
          selection = localStorage["selected_cleaner_ids"].split(",");
          selection.forEach(id => {
            if (t.cleanerDict[id])
              t.cleanerDict[id].selected = true;
            t.list.selectedCleaner.push(t.cleanerDict[id]);
          });
        }

        t.list.cleaner = items;
        t.loadData();
      }
    });

    let todayText = t.today.format("MM/dd");

    for (let i = 1; i <= t.days; i++) {
      let d = new Date(t.startDate.format("yyyy/MM/dd"));

      d.setDate(d.getDate() + i - 1);

      let date = d.format("MM/dd");

      t.monthGrid[date] = {
        k: 0,
        s: 0,
        suffix: ["日", "月", "火", "水", "木", "金", "土"][d.getDay()],
        is_today: date == todayText,
        day_index: d.getDay(),
        is_past: t.today > d
      };
    }

    function refreshStats() {
      axios.get("order/stats4Dashboard").then((res) => {
        if (res.data.status == 1) {
          t.stats = res.data.options.stats;
        }
      });
    }

    refreshStats();

    setInterval(function () {
      refreshStats();
    }, 1000 * 10);

  },
  activated() {
    let t = this;
  },
  methods: {

    formatter(day) {
      let t = this;

      if (day.date.format('yyyy/MM/dd') == t.todayText) {
        day.bottomInfo = '今日';
        day.className = '_today';
      }
      return day;
    },

    reportFinish() {
      let t = this;

      if (t.gridItem.checkOutItem) {
        t.gridItem.checkOutItem.clean_is_finish = 1;
        t.gridItem.checkOutItem.clean_status = 3;
      }
      else {
        t.gridItem.clean_is_finish = 1;
        t.gridItem.clean_status = 3;
      }

      t.boxName = 'report-status';

    },

    reportReset() {
      let t = this;

      if (t.gridItem.checkOutItem) {
        t.gridItem.checkOutItem.clean_is_finish = 1;
        t.gridItem.checkOutItem.clean_status = 2;
      }
      else {
        t.gridItem.clean_is_finish = 1;
        t.gridItem.clean_status = 2;
      }

      t.boxName = 'report-status';
    },

    showReport() {
      let t = this;

      t.cleanTaskId = null;

      if (t.gridItem.checkOutItem.clean_status == 3) {
        t.cleanTaskId = t.gridItem.checkOutItem.task_id;
      }
      else if (t.gridItem.clean_status == 3) {
        t.cleanTaskId = t.gridItem.task_id;
      }

      if (/localhost/.test(location.host)) {
        t.cleanTaskId = 2956;
      }

      if (!t.cleanTaskId) {
        A.err('日報未提出');
        return;
      }

      t.boxName = 'report';
    },

    goFillForm() {
      this.boxName = 'fill-form';
    },

    afterFormSubmitted(form_id) {
      this.gridItem.checkInItem.form_id = form_id;
      this.boxName = 'normal';
    },

    tapGridItem(item) {
      let t = this;

      if (!item.checkInItem) {
        if (item.nextCheckInItem) {
          item.checkInItem = item.nextCheckInItem;
        }
        else {
          if (item.is_continuous) {
            t.gridItem = item;
            t.boxName = 'set-cleaner';
            t.editCleaner();
            t.showWindow = true;
          }
          return;
        }
      }
      else {
        item.checkInItem = item.checkInItem;
      }

      // if (!item.checkOutItem) {
      //   item.checkOutItem = {};
      // }

      t.gridItem = item;


      if (item.checkInItem.emergency_status == 2) {
        t.boxName = 'emergency-order';
      }
      else if (!t.gridItem.cleaner_id && (!t.gridItem.checkOutItem || (t.gridItem.checkOutItem && !t.gridItem.checkOutItem.cleaner_id))) {
        t.boxName = 'set-cleaner';
        t.editCleaner();
      }
      else if (item.checkInItem.emergency_status == 3) {
        t.boxName = 'changed-people';
      }
      else if (item.checkInItem != item.nextCheckInItem && item.checkInItem.form_status == 1) {
        t.boxName = 'unfill';
      }
      else if (t.gridItem.clean_is_finish == 0) {
        t.boxName = 'report-status';
      }
      else {
        t.boxName = 'normal';
      }

      t.showWindow = true;
    },

    confirmReport() {

    },

    scrollToDate(date) {
      this.$refs.calendar.scrollToDate(date);
    },

    cacheValue(v) {
      localStorage[v] = this[v];
    },

    loadData() {
      let t = this;

      t.inited = false;

      t.roomGrid = {};
      t.checkInDict = {};
      t.checkOutDict = {};
      t.extraTaskDict = {};
      t.roomCheckInDict = {};
      t.ksDict = {};
      t.roomDict = {};

      t.disposed = true;

      setTimeout(function () {

        t.disposed = false;
        t.$forceUpdate();

        axios.get("room").then((res) => {
          if (res.data.status == 1) {
            let arr = res.data.options.items;

            arr.forEach((room) => {
              room.invisible = false;
              room.selected = false;
              room.active = false;
              t.roomDict[room.id] = room;
            });

            t.list.room = arr;

            axios.get("group").then((res) => {
              if (res.data.status == 1) {
                let arr = res.data.options.items;

                // let selection = [];
                // let groupDict = listToDict(arr);

                // t.list.selectedGroup = [];

                // if (localStorage["selected_group_ids"]) {
                //   selection = localStorage["selected_group_ids"].split(",");
                //   selection.forEach(id => {
                //     if (groupDict[id])
                //       t.list.selectedGroup.push(groupDict[id]);
                //   });
                // }

                arr.forEach((group) => {
                  group.editing = false;
                  group.selected = false;
                  group.expanded = true;
                  group.rooms = [];
                  if (group.room_ids) {
                    let roomIds = group.room_ids.split(",");
                    roomIds.forEach((roomId) => {
                      t.roomDict[roomId].selected = true;
                      group.rooms.push(t.roomDict[roomId]);
                    });
                  }
                });

                let ids = [];

                if (localStorage['selected_group_ids']) {
                  ids = localStorage['selected_group_ids'].split(',');
                }

                t.dict.group = listToDict(arr);

                ids.forEach(id => {
                  if (t.dict.group[id]) {
                    t.list.group.push(t.dict.group[id]);
                    arr.remove(t.dict.group[id]);
                  }
                });

                arr.forEach(group => {
                  t.list.group.push(group);
                });

                let selectedRoomIds = [];

                t.list.selectedGroup.forEach(group => {
                  let roomIds = group.room_ids.split(",");
                  selectedRoomIds.append(roomIds);
                });

                let p = {
                  '_with': 'tasks',
                  'date': t.startDate.format("yyyy/MM/dd"),
                  'endDate': t.endDate.format("yyyy/MM/dd"),
                  'room_id': selectedRoomIds.join(',')
                };

                axios
                  .get("order", { params: p })
                  .then((res) => {
                    if (res.data.status == 1) {
                      let arr = res.data.options.items;

                      arr.forEach((order) => {
                        order.clean_is_finish = 0;
                        let checkInDate = order.checkin_date
                          .replace(/\d{4}[\/-]/, "")
                          .replace("-", "/");
                        if (!t.checkInDict[checkInDate])
                          t.checkInDict[checkInDate] = {};
                        t.checkInDict[checkInDate][order.room_id] = order;

                        if (!t.roomCheckInDict[order.room_id])
                          t.roomCheckInDict[order.room_id] = {};
                        t.roomCheckInDict[order.room_id][checkInDate] = order;

                        if (!t.ksDict[checkInDate])
                          t.ksDict[checkInDate] = { k: 0, s: 0, d: 0 };

                        if (order.k) {
                          t.ksDict[checkInDate].k += Number(order.k);
                          t.ksTotal.k += Number(order.k);
                        }

                        if (order.s) {
                          t.ksDict[checkInDate].s += Number(order.s);
                          t.ksTotal.s += Number(order.s);
                        }

                        if (order.d) {
                          t.ksDict[checkInDate].d += Number(order.d);
                          t.ksTotal.d += Number(order.d);
                        }

                        let checkOutDate = order.checkout_date
                          .replace(/\d{4}[\/-]/, "")
                          .replace("-", "/");

                        if (!t.checkOutDict[checkOutDate])
                          t.checkOutDict[checkOutDate] = {};
                        t.checkOutDict[checkOutDate][order.room_id] = order;

                        if (order.tasks) {
                          order.tasks.forEach((task) => {
                            if (task.is_extra == 1) {
                              let cleanDate = task.date
                                .replace(/\d{4}[\/-]/, "")
                                .replace("-", "/");
                              if (!t.extraTaskDict[cleanDate])
                                t.extraTaskDict[cleanDate] = {};
                              t.extraTaskDict[cleanDate][order.room_id] = task;
                            }
                            else {
                              order.clean_is_finish = task.is_finish;
                            }
                          });
                        }
                      });

                      let dateExtras = res.data.options.date_extras;

                      if (dateExtras)
                        dateExtras.forEach((item) => {
                          if (!t.dateExtraDict[item.room_id])
                            t.dateExtraDict[item.room_id] = {};
                          t.dateExtraDict[item.room_id][item.date] = item;
                        });

                      t.initRoomGrid();

                      t.refreshCurrentStats();

                      //t.tapGridItem(t.roomGrid['06/27'][63]);
                    }
                  });
              }
            });
          }
        });

      }, 100);
    },

    refreshGroupIndex() {

      let t = this;

      let ids = [];

      t.list.group.forEach(group => {
        ids.push(group.id);
      });

      localStorage['selected_group_ids'] = ids.join(',');
    },

    refreshDateItem(gridItem) {
      let t = this;

      gridItem.bg_color = "bg-pink";

      if (gridItem.clean_status == 99) {
        //无清扫员
        gridItem.bg_color = "bg-pink";
      } else if (gridItem.clean_status == 1) {
        //有清扫员
        let cleanDeadline = new Date(
          gridItem.checkout_date + " 13:00:00"
        ).valueOf();
        let now = new Date().valueOf();
        if (now > cleanDeadline) {
          gridItem.clean_delayed = true;
          gridItem.bg_color = "bg-red";
        } else gridItem.bg_color = "bg-pink";
      } else if (gridItem.clean_status == 2) {
        //正在清扫
        gridItem.bg_color = "bg-yellow";
      } else if (gridItem.clean_status == 3) {
        //清扫完成
        gridItem.bg_color = "bg-green";
      }

      let d = new Date(t.today.getFullYear() + "/" + gridItem.date);
      let d2 = new Date(t.today.format("yyyy/MM/dd"));

      d2.setDate(d2.getDate() + 3);

      if (
        gridItem.clean_status == 99 &&
        d2 > d &&
        d >= new Date(t.today.format("yyyy/MM/dd"))
      ) {
        gridItem.bg_color = "bg-orange";
      }

      if (gridItem.checkin_date) {
        d = new Date(gridItem.checkin_date);
        d2 = new Date(t.today.getFullYear() + "/" + gridItem.date);

        d = d.format("yyyy/MM/dd");
        d2 = d2.format("yyyy/MM/dd");

        if (d == d2 && gridItem.override_clean_status == 3) {
          gridItem.bg_color = "bg-green";
        }
      }
    },

    refreshContinuous(gridItem, grid) {
      let t = this;

      let checkInItem = gridItem.checkInItem;

      if (checkInItem && checkInItem.continuous_days > 1) {

        gridItem.continuous_days = checkInItem.continuous_days;

        let room = t.roomDict[gridItem.room_id];

        let date = new Date(checkInItem.checkin_date).format("MM/dd");

        for (let i = 1; i < checkInItem.continuous_days; i++) {
          let d = new Date(date);

          d.setDate(d.getDate() + i);

          let date2 = d.format("MM/dd");

          if (!grid[date2]) grid[date2] = {};

          let dateItem = grid[date2][room.id];

          if (!dateItem)
            dateItem = grid[date2][room.id] = {
              room_name: room.name,
              room_id: room.id,
              date: date2,
              id: null,
              cleaner_name: "",
              cleaner_id: 0,
              clean_is_finish: 0,
              source: "",
              status: 99,
              bg_color: "bg-grey",
              continuous_days: 0,
              is_continuous: false,
              is_last_continuous: false,
              cid: null,
              emergency_status: 0,
            };

          dateItem.sourceItem = checkInItem;
          dateItem.is_continuous = true;
          dateItem.is_last_continuous = i == checkInItem.continuous_days - 1;
          dateItem.bg_color = gridItem.bg_color + "2";
          dateItem.sourceCheckInItem = gridItem.checkInItem;

          if (t.extraTaskDict[date2] && t.extraTaskDict[date2][room.id]) {
            let task = t.extraTaskDict[date2][room.id];
            if (task.cleaner_id) {
              dateItem.task_id = task.id;
              dateItem.cleaner_id = task.cleaner_id;
              dateItem.cleaner_name = t.cleanerDict[task.cleaner_id].name;
              dateItem.clean_status = task.status;
            }
            t.refreshDateItem(dateItem);
          }
        }
      }
    },

    refreshCurrentStats() {

      let t = this;

      t.currentStats = {
        task: 0,
        continuous: 0,
        empty: 0,
        checkin: 0
      };

      let currentDateStr = t.currentDate.format('MM/dd');

      t.list.group.forEach(group => {

        group.rooms.forEach(room => {

          for (const date in t.monthGrid) {

            let gridItem = t.roomGrid[date][room.id];

            if (gridItem) {
              gridItem.isCurrentDate = false;
              gridItem.isA = !!((gridItem.checkOutItem && !!gridItem.checkOutItem.cleaner_id) ||
                (gridItem.checkInItem && gridItem.checkInItem.emergency_status == 2) ||
                (gridItem.checkInItem && gridItem.checkInItem.emergency_status == 3) ||
                gridItem.checkOutItem);
              gridItem.isB = gridItem.is_continuous;
              gridItem.isC = !gridItem.checkInItem && !gridItem.is_continuous;
              gridItem.isD = !!(gridItem.checkInItem);

              if (currentDateStr == date) {

                gridItem.isCurrentDate = true;

                if (gridItem.isA)
                  t.currentStats.task++;

                if (gridItem.isB)
                  t.currentStats.continuous++;

                if (gridItem.isC)
                  t.currentStats.empty++;

                if (gridItem.isD)
                  t.currentStats.checkin++;
              }
            }
          }

        });
      });
    },

    initRoomGrid() {
      let t = this;
      let grid = {};

      function fillGrid() {
        t.list.group.forEach((group) => {
          group.rooms.forEach((room) => {
            for (let j = -15; j <= t.days + 15; j++) {
              let d = new Date(t.startDate.format("yyyy/MM/dd"));

              d.setDate(d.getDate() + j - 1);

              let date = d.format("MM/dd");

              if (!grid[date]) grid[date] = {};

              let gridItem = grid[date][room.id];

              if (!gridItem)
                gridItem = grid[date][room.id] = {
                  room_name: room.name,
                  room_id: room.id,
                  date: date,
                  id: null,
                  cleaner_name: "",
                  cleaner_id: 0,
                  clean_is_finish: 0,
                  // source: '',
                  status: 99,
                  bg_color: "",
                  continuous_days: 0,
                  is_continuous: false,
                  is_last_continuous: false,
                  cid: null,
                  emergency_status: 0,
                };

              if (t.checkInDict[date] && t.checkInDict[date][room.id]) {
                let checkInItem = {};

                checkInItem.date = date;

                // checkInItem.bg_color = 'bg-pink';

                mirror(t.checkInDict[date][room.id], checkInItem);

                checkInItem.bell_color = "fill-white";

                if (checkInItem.form_status == 1)
                  checkInItem.bell_color = "fill-red";

                if (
                  new Date(t.today.getFullYear() + "/" + date).valueOf() <
                  t.today.valueOf()
                )
                  checkInItem.bell_color = "fill-outline";

                t.refreshDateItem(checkInItem);

                gridItem.checkInItem = checkInItem;
              }

              if (t.checkOutDict[date] && t.checkOutDict[date][room.id]) {
                let checkOutItem = {};

                checkOutItem.date = date;

                mirror(t.checkOutDict[date][room.id], checkOutItem);

                t.refreshDateItem(checkOutItem);

                gridItem.checkOutItem = checkOutItem;
              }

              if (gridItem.checkInItem) {
                gridItem.checkInItem.room_name = gridItem.room_name;

                gridItem.checkInItem.room_id = gridItem.room_id;

                gridItem.checkInItem.dateInGrid = date;
              }

              if (gridItem.checkInItem) {
                let checkInItem = gridItem.checkInItem;

                gridItem.bg_color = checkInItem.bg_color;

                if (checkInItem.continuous_days > 1) {
                  for (let i = 1; i < checkInItem.continuous_days; i++) {
                    let d = new Date(date);

                    d.setDate(d.getDate() + i);

                    let date2 = d.format("MM/dd");

                    if (!grid[date2]) grid[date2] = {};

                    let dateItem = grid[date2][room.id];

                    if (!dateItem)
                      dateItem = grid[date2][room.id] = {
                        room_name: room.name,
                        room_id: room.id,
                        date: date2,
                        id: null,
                        cleaner_name: "",
                        cleaner_id: 0,
                        clean_is_finish: 0,
                        source: "",
                        status: 99,
                        bg_color: "bg-grey",
                        continuous_days: 0,
                        is_continuous: false,
                        is_last_continuous: false,
                        cid: null,
                        emergency_status: 0,
                      };

                    dateItem.sourceItem = checkInItem;
                    dateItem.is_continuous = true;
                    dateItem.is_last_continuous =
                      i == checkInItem.continuous_days - 1;
                    dateItem.bg_color = gridItem.bg_color + "2";
                    dateItem.continuous_bg_color = gridItem.bg_color + "2";

                    if (
                      t.extraTaskDict[date2] &&
                      t.extraTaskDict[date2][room.id]
                    ) {
                      let task = t.extraTaskDict[date2][room.id];
                      if (task.cleaner_id) {
                        dateItem.cleaner_id = task.cleaner_id;
                        dateItem.cleaner_name =
                          t.cleanerDict[task.cleaner_id].name;
                      }
                      t.refreshDateItem(dateItem);
                    }
                  }
                }

                t.refreshContinuous(gridItem, grid);
              }

              if (gridItem.checkOutItem) {
                let checkOutItem = gridItem.checkOutItem;
                gridItem.bg_color = checkOutItem.bg_color;
                t.refreshContinuous(gridItem, grid);
              }
            }
          });
        });

        t.list.group.forEach((group) => {
          group.rooms.forEach((room) => {
            for (let j = -15; j <= t.days + 15; j++) {
              let d = new Date(t.startDate.format("yyyy/MM/dd"));

              d.setDate(d.getDate() + j - 1);

              let date = d.format("MM/dd");

              if (!grid[date]) grid[date] = {};

              let gridItem = grid[date][room.id];

              if (gridItem.checkOutItem && !gridItem.checkInItem) {
                let minDateVal = 0;
                let minDate = "";
                let dateVal = new Date(
                  t.today.getFullYear() + "/" + date
                ).valueOf();

                for (const date2 in t.roomCheckInDict[room.id]) {
                  let date2Val = new Date(
                    t.today.getFullYear() + "/" + date2
                  ).valueOf();

                  if (date2Val > dateVal) {
                    if (minDateVal == 0) {
                      minDateVal = date2Val;
                      minDate = date2;
                    } else if (date2Val < minDateVal) {
                      minDateVal = date2Val;
                      minDate = date2;
                    }
                  }
                }

                if (minDate) {
                  if (
                    grid[minDate] &&
                    grid[minDate][room.id] &&
                    grid[minDate][room.id].checkInItem
                  ) {
                    gridItem.nextCheckInItem =
                      grid[minDate][room.id].checkInItem;
                    gridItem.nextCheckInGridItem = grid[minDate][room.id];

                    if (gridItem.nextCheckInItem) {
                      gridItem.nextCheckInItem.cleaned_at = date;
                      gridItem.nextCheckInItem.bg_color = gridItem.bg_color;
                      gridItem.nextCheckInGridItem.bg_color = gridItem.bg_color;

                      let checkInItem = gridItem.nextCheckInItem;
                      if (checkInItem.continuous_days > 1) {
                        for (let i = 1; i < checkInItem.continuous_days; i++) {
                          let d = new Date(checkInItem.date);

                          d.setDate(d.getDate() + i);

                          let date2 = d.format("MM/dd");

                          if (!grid[date2]) grid[date2] = {};

                          let dateItem = grid[date2][room.id];

                          dateItem.sourceItem = checkInItem;
                          dateItem.is_continuous = true;
                          dateItem.is_last_continuous =
                            i == checkInItem.continuous_days - 1;
                          dateItem.bg_color = gridItem.bg_color + "2";
                          dateItem.continuous_bg_color =
                            gridItem.bg_color + "2";

                          if (
                            t.extraTaskDict[date2] &&
                            t.extraTaskDict[date2][room.id]
                          ) {
                            let task = t.extraTaskDict[date2][room.id];
                            if (task.cleaner_id) {
                              dateItem.cleaner_id = task.cleaner_id;
                              dateItem.cleaner_name =
                                t.cleanerDict[task.cleaner_id].name;
                            }
                            t.refreshDateItem(dateItem);
                          }
                        }
                      }

                      t.refreshContinuous(
                        gridItem.nextCheckInGridItem,
                        t.roomGrid
                      );
                    }

                    let fullDate = new Date(
                      t.today.getFullYear() + "/" + gridItem.date
                    ).format("yyyy-MM-dd");

                    if (
                      t.dateExtraDict[room.id] &&
                      t.dateExtraDict[room.id][fullDate]
                    ) {
                      let dateExtra = t.dateExtraDict[room.id][fullDate];
                      gridItem.dateExtra = dateExtra;
                    }
                  }
                }
              }
            }
          });
        });
      }

      fillGrid();

      t.roomGrid = grid;

      t.inited = true;
    },

    printA3() {
      if (window._printStyleTag) window._printStyleTag.remove();
      // transform: scale(0.9) !important;
      let style = "@media print { @page {  size: A3 landscape !important; } .room-rows { zoom:0.9 !important;   transform-origin: left top; } }";

      let s = document.createElement("style");
      s.innerHTML = style;
      document.body.appendChild(s);
      window._printStyleTag = s;
      window.print();
    },

    printA4() {
      if (window._printStyleTag) window._printStyleTag.remove();
      let style = "@media print { @page {  size: A4 landscape !important; } .room-rows { zoom:0.62 !important;  transform-origin: left top; } }";

      let s = document.createElement("style");
      s.innerHTML = style;
      document.body.appendChild(s);
      window._printStyleTag = s;
      window.print();
    },

    refreshSelection() {
      let t = this;
      let arr = [];

      let res = t.$refs.sortPicker.selection;

      if (res.length > 0) {

        res.forEach(item => {
          arr.push(item.id);
          item.selected = true;
        });
        localStorage["selected_cleaner_ids"] = arr.join(",");
      }

      t.list.selectedCleaner.clear();
      t.list.selectedCleaner.append(res);
      t.$forceUpdate();


    },

    refreshGroupSelection() {
      let t = this;
      let arr = [];

      let res = t.$refs.sortPicker2.selection;

      if (res.length > 0) {

        res.forEach(item => {
          arr.push(item.id);
        });
        localStorage["selected_group_ids"] = arr.join(",");
      }

      t.list.selectedGroup.clear();
      t.list.selectedGroup.append(res);
      t.loadData();
      t.$forceUpdate();
    },

    editCleaner() {

      let t = this;

      let gridItem = t.gridItem;

      if (gridItem.checkOutItem) {
        t.selectedStatus = t.statusDict[gridItem.checkOutItem.clean_status];
        t.selectedCleaner = t.cleanerDict[gridItem.checkOutItem.cleaner_id];
        gridItem.cid = gridItem.checkOutItem.cleaner_id;
      }
      else if (gridItem.is_continuous && gridItem.task_id) {
        t.selectedStatus = t.statusDict[gridItem.clean_status];
        t.selectedCleaner = t.cleanerDict[gridItem.cleaner_id];
        gridItem.cid = gridItem.cleaner_id;
      }
    },

    saveCleaner() {
      let t = this;

      let gridItem = t.gridItem;

      gridItem.sourceCheckInItem = gridItem.checkInItem;

      let cid;

      if (t.selectedCleaner == -1)
        cid = null;
      else if (t.selectedCleaner)
        cid = t.selectedCleaner.id;

      if (t.busying)
        return;

      t.busying = true;

      let f = { cleaner_id: cid };

      if (t.gridItem.checkOutItem && t.gridItem.checkOutItem.id) {
        f.id = t.gridItem.checkOutItem.id;
        f.clean_status = 1;
        if (t.selectedStatus)
          f.clean_status = t.selectedStatus.id;
      }

      axios.post('order/setCleaner', f).then(res => {

        t.busying = false;

        if (res.data.status == 1) {
          if (cid) {

            A.toast('Saved.');

            if (gridItem.is_continuous) {

              gridItem.checkOutItem.cleaner_id = cid;
              gridItem.checkOutItem.clean_status = f.clean_status;
              gridItem.checkOutItem.cleaner_name = t.cleanerDict[gridItem.checkOutItem.cleaner_id].name;

              t.refreshDateItem(gridItem, true);
            }
            else {
              gridItem.checkOutItem.cleaner_id = cid;
              gridItem.checkOutItem.clean_status = f.clean_status;
              gridItem.checkOutItem.cleaner_name = t.cleanerDict[gridItem.checkOutItem.cleaner_id].name;

              t.refreshDateItem(gridItem.checkOutItem, true);
              gridItem.bg_color = gridItem.checkOutItem.bg_color;

              if (gridItem.nextCheckInItem) {
                gridItem.nextCheckInItem.bg_color = gridItem.bg_color;
                gridItem.nextCheckInGridItem.bg_color = gridItem.bg_color;
                t.refreshContinuous(gridItem.nextCheckInGridItem, t.roomGrid);
              }
            }


          }
          else {
            if (gridItem.is_continuous) {

              gridItem.checkOutItem.cleaner_id = null;
              gridItem.checkOutItem.clean_status = 99;
              gridItem.checkOutItem.cleaner_name = null;

              gridItem.checkOutItem.bg_color = gridItem.checkOutItem.continuous_bg_color;
            }
            else {
              gridItem.checkOutItem.cleaner_id = null;
              gridItem.checkOutItem.clean_status = 99;
              gridItem.checkOutItem.cleaner_name = null;

              t.refreshDateItem(gridItem.checkOutItem, true);
              gridItem.bg_color = gridItem.checkOutItem.bg_color;
            }
          }

          t.refreshContinuous(gridItem, t.roomGrid);

          t.showCleanerEditor = false;
        }
      });
    },

    resetFilters() {
      let t = this;
      if (!t.filterName) {
        t.showFilter = false;
      }
      else {
        t.filterName = '';
      }
    },

    removeTag(item) {
      item.selected = false;
    },
    selectTag(item) {
      let t = this;
      item.selected = !item.selected;
    },

    openFilter(name) {

      let t = this;

      if (t.filterName == name) {
        t.filterName = '';
      }
      else {
        t.filterName = name;
      }

    },

    selectAll(key) {
      let t = this;

      if (key == 'tag') {
        t.list[key].forEach(item => {
          item.selected = true;
        });
      }
      else if (t.list[key] && t.search[key]) {
        t.search[key].clear();
        t.list[key].forEach(item => {
          item._active = true;
          t.search[key].push(item);
        });
      }

      t.$forceUpdate();
    },

    deselectAll(key) {
      let t = this;

      if (key == 'tag') {
        t.list[key].forEach(item => {
          item.selected = false;
        });
      }
      else if (t.list[key] && t.search[key]) {
        t.search[key].clear();
        t.list[key].forEach(item => {
          item._active = false;
        });
      }
      t.$forceUpdate();
    },

    refreshToggles(key) {

      let t = this;
      t.toggle[key] = !t.toggle[key];

      switch (key) {
        case 'task':
          if (t.toggle.task)
            t.toggle.continuous = t.toggle.checkin = t.toggle.empty = t.toggle.all = false;
          else
            t.toggle.continuous = t.toggle.checkin = t.toggle.empty = true;
          break;

        case 'continuous':
          if (t.toggle.continuous)
            t.toggle.task = t.toggle.checkin = t.toggle.empty = t.toggle.all = false;
          else
            t.toggle.task = t.toggle.checkin = t.toggle.empty = true;
          break;
        case 'checkin':

          if (t.toggle.checkin)
            t.toggle.task = t.toggle.continuous = t.toggle.empty = t.toggle.all = false;
          else
            t.toggle.task = t.toggle.continuous = t.toggle.empty = true;
          break;
        case 'empty':

          if (t.toggle.empty)
            t.toggle.task = t.toggle.continuous = t.toggle.checkin = t.toggle.all = false;
          else
            t.toggle.task = t.toggle.continuous = t.toggle.checkin = true;
          break;
        case 'all':

          if (t.toggle.all) {
            t.toggle.task = t.toggle.continuous = t.toggle.checkin = t.toggle.empty = false;
          }
          else {
            t.toggle.continuous = t.toggle.checkin = t.toggle.empty = false;
            t.toggle.task = true;
          }
          break;

      }

      if (key != 'all') {
        if (!t.toggle.task && !t.toggle.continuous && !t.toggle.checkin && !t.toggle.empty)
          t.toggle.all = true;
      }

      t.refreshInvisible();
    },

    refreshInvisible() {
      let t = this;
      let date = t.currentDate.format('MM/dd');
      let roomGrid = t.roomGrid;

      t.list.group.forEach(group => {

        group.rooms.forEach(room => {

          if (t.toggle.all) {
            room.invisible = false;
          }
          else {
            room.invisible = true;

            if ((roomGrid[date][room.id].isA && t.toggle.task) ||
              (roomGrid[date][room.id].isB && t.toggle.continuous) ||
              (roomGrid[date][room.id].isC && t.toggle.empty) ||
              (roomGrid[date][room.id].isD && t.toggle.checkin))
              room.invisible = false;
          }
        });

      });
    },

    editGroup(group) {
      let t = this;
      if (t.curGroup) {
        t.curGroup.selected = false;
      }
      group.editing = true;
      t.$forceUpdate();
    },

    saveGroup(group) {
      let t = this;

      if (t.busying)
        return;

      group.editing = false;

      t.busying = true;

      let f = { name: group.name };

      let ids = [];

      group.rooms.forEach(room => {
        ids.push(room.id);
      });

      f.room_ids = ids.join(',');

      axios.put('group/' + group.id, f).then(res => {

        t.busying = false;

        if (res.data.status == 1) {
          A.toast('Saved.');
        }
      });

    },

    removeGroup(group) {
      let t = this;

      if (t.busying)
        return;

      t.busying = true;

      t.list.group.remove(group);

      axios.delete('group/' + group.id).then(res => {
        t.busying = false;
        if (res.data.status == 1) {

        }
      });

    },

    addGroup(idx) {
      let t = this;

      let f = {
        'name': '未命名'
      };
      if (t.busying)
        return;

      t.busying = true;

      axios.post('group', f).then(res => {

        t.busying = false;

        if (res.data.status == 1) {
          let group = res.data.options;
          group.rooms = [];
          group.editing = false;
          group.selected = false;
          group.expanded = true;
          t.list.group.push(group);
          t.refreshGroupIndex();
          t.$nextTick(() => {
            let ele = document.getElementById('groupItems');
            ele.scrollTop = ele.scrollHeight;
          });
          t.$forceUpdate();
        }
      });
    },

    selectGroup(group) {
      let t = this;
      if (t.curGroup) {
        t.curGroup.selected = false;
      }
      if (t.curGroup != group) {
        t.curGroup = group;
        group.selected = true;
      }
      else {
        t.curGroup = null;
      }
    },

    moveUp() {
      let t = this;
      if (t.curGroup && t.curGroup.selected) {
        let idx = t.list.group.indexOf(t.curGroup);
        if (idx > 0) {
          let o = t.list.group[idx - 1];
          t.list.group[idx - 1] = t.curGroup;
          t.list.group[idx] = o;
          t.$forceUpdate();
        }
      }
    },

    moveDown() {
      let t = this;
      if (t.curGroup && t.curGroup.selected) {
        let idx = t.list.group.indexOf(t.curGroup);
        if (idx < t.list.group.length - 1) {
          let o = t.list.group[idx + 1];
          t.list.group[idx + 1] = t.curGroup;
          t.list.group[idx] = o;
          t.$forceUpdate();
        }
      }
    },

    moveUp2() {
      let t = this;
      if (t.curRoom) {
        let idx = t.curGroup.rooms.indexOf(t.curRoom);
        if (idx > 0) {
          let o = t.curGroup.rooms[idx - 1];
          t.curGroup.rooms[idx - 1] = t.curRoom;
          t.curGroup.rooms[idx] = o;
          t.$forceUpdate();
        }
      }
    },

    moveDown2() {
      let t = this;
      if (t.curRoom) {
        let idx = t.curGroup.rooms.indexOf(t.curRoom);
        if (idx < t.curGroup.rooms.length - 1) {
          let o = t.curGroup.rooms[idx + 1];
          t.curGroup.rooms[idx + 1] = t.curRoom;
          t.curGroup.rooms[idx] = o;
          t.$forceUpdate();
        }
      }
    },

    moveRight() {

      let t = this;

      if (t.curRoom) {
        t.curGroup.rooms.remove(t.curRoom);
        t.fakeId++;
      }

    },

    moveRight2() {
      let t = this;

      t.curGroup.rooms.clear();

      t.fakeId++;

    },

    moveLeft() {
      let t = this;

      let arr = t.filteredRooms;

      arr.forEach(room => {
        if (room.active) {
          room.selected = true;
          t.curGroup.rooms.push(room);
        }
      });

      t.initRoomGrid();

      t.fakeId++;
    },

    moveLeft2() {
      let t = this;

      let arr = t.filteredRooms;

      arr.forEach(room => {
        room.selected = true;
        t.curGroup.rooms.push(room);
      });

      t.initRoomGrid();

      t.fakeId++;

    },

    selectRoom(room) {
      let t = this;
      if (t.curRoom != room) {
        t.curRoom = room;
      }
      else {
        t.curRoom = null;
      }
    },

    closeWin() {
      let t = this;
      t.boxName = 'normal';
    },

    calcKS() {
      let t = this;
      let f = t.orderForm;

      if (!f.room_id)
        return;

      let room = t.roomDict[f.room_id];
      if (!room) return;
      let type = room.type;

      let k = 0, s = 0, d = 0;
      let countTotal = Number(f.count_audlt) + Number(f.count_child);

      const kByType = { A: 1, B: 2, C: 1, D: 0, E1: 0, E2: 0, F1: 1, F2: 1 };
      const dByType = { A: 0, B: 0, C: 0, D: 0, E1: 2, E2: 3, F1: 2, F2: 3 };
      const sTable = {
        A:  [0, 1, 2, 2, 3, 4, 5, 6, 7, 8, 9],
        B:  [0, 1, 2, 1, 2, 3, 4, 5, 6, 7, 8],
        C:  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        D:  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        E1: [0, 1, 2, 1, 2, 3, 4, 5, 6, 7, 8],
        E2: [0, 1, 1, 1, 1, 3, 4, 5, 6, 7, 8],
        F1: [0, 1, 1, 2, 2, 2, 3, 4, 5, 6, 7],
        F2: [0, 1, 1, 1, 1, 3, 3, 4, 5, 6, 7],
      };
      const sOver10Sub = { A: 1, B: 2, C: null, D: 0, E1: 2, E2: 2, F1: 3, F2: 3 };

      if (kByType[type] !== undefined) {
        k = kByType[type];
        d = dByType[type];
        let p = countTotal;
        if (p <= 10) {
          s = sTable[type][Math.max(0, p)];
        } else if (type == 'C') {
          s = 0;
        } else {
          s = p - sOver10Sub[type];
        }
      } else {
        k = Math.ceil(f.count_audlt / 2.0);
      }

      t.orderForm.k = k;
      t.orderForm.s = s;
      t.orderForm.d = d;

      t.$forceUpdate();
    },

    editOrder() {
      let t = this;
      t.orderForm = {};
      if (t.gridItem.checkInItem && t.gridItem.checkInItem != t.gridItem.nextCheckInItem) {
        t.orderForm = {};
        mirror(t.gridItem.checkInItem, t.orderForm);
      }
      else {
        mirror(t.orderForm_o, t.orderForm);
        t.orderForm.checkin_date = t.gridItem.year + '/' + t.gridItem.date;
        t.orderForm.source = 'MM';
        t.orderForm.room_id = t.gridItem.room_id;
        t.calcKS();
      }
    },

    openBox(type) {

      let t = this;

      if (t.gridItem.checkInItem.emergency_status == 2) {
        A.err('急予約の処理を完了してください。');
        return;
      }

      if (type == 'status') {

        if (t.gridItem.checkInItem != t.gridItem.nextCheckInItem && t.gridItem.checkInItem.form_status == 1) {
          t.boxName = 'unfill';
        }
        else if (t.gridItem.checkInItem.form_id) {
          t.boxName = 'view-form';
        }

      }

      else if (type == 'people') {
        if (t.gridItem.checkInItem.emergency_status == 3) {
          t.boxName = 'changed-people';
        }
        else {
          t.boxName = 'normal-people';
        }
      }

      else if (type == 'order') {
        t.boxName = 'edit-order';
        t.editOrder();
      }

      else if (type == 'cleaner') {
        t.boxName = 'set-cleaner';
        t.editCleaner();
      }

      else if (type == 'report-status') {
        t.boxName = 'report-status';
      }

      else if (type == 'profile') {
        if (t.gridItem.checkInItem != t.gridItem.nextCheckInItem && t.gridItem.checkInItem.form_status == 1) {
          t.boxName = 'unfill';
        }
        else {
          t.boxName = 'normal';
        }
      }
    },

    saveOrder() {
      let t = this;

      let f = t.orderForm;

      if (!f.checkin_date) {
        A.err('Please enter check-in date')
        return;
      }

      if (!f.checkout_date) {
        A.err('Please enter check-out date')
        return;
      }

      let leftDays = t.calcDateDiffDays(f.checkin_date, f.checkout_date);

      if (leftDays < 1) {
        A.err('Please check the check-out date')
        return;
      }

      f.continuous_days = leftDays;

      if (t.busying)
        return;

      t.busying = true;

      f.room_id = t.gridItem.room_id;

      let fields = ['room_id', 'checkin_date', 'checkout_date', 'count_audlt', 'count_child', 'count_baby', 'remark', 'source', 'continuous_days', 'k', 's', 'd'];

      let data = getFields(f, fields);

      if (f.id) {
        axios.put('order/' + f.id, data).then(res => {

          t.busying = false;

          if (res.data.status == 1) {
            A.toast('Saved.');
          }
        });
      }
      else {
        axios.post('order', data).then(res => {

          t.busying = false;

          if (res.data.status == 1) {
            A.toast('Saved.');
          }
        });
      }

    },

    resolveEmergency2() {
      let t = this;

      let gridItem = t.gridItem;

      if (t.busying)
        return;

      t.busying = true;

      axios.put('order/' + gridItem.checkInItem.id, { emergency_status: 1 }).then(res => {

        t.busying = false;

        if (res.data.status == 1) {
          gridItem.emergency_status = 1;
          gridItem.checkInItem.emergency_status = 1;
          A.toast('Saved.');
          t.resolve();
        }
      });
    },

    resolveEmergency3() {
      let t = this;

      let gridItem = t.gridItem;

      if (t.busying)
        return;

      t.busying = true;

      if (gridItem.checkInItem.id) {
        axios.put('order/' + gridItem.checkInItem.id, { emergency_status: 1 }).then(res => {

          t.busying = false;

          if (res.data.status == 1) {
            gridItem.emergency_status = 1;
            gridItem.checkInItem.emergency_status = 1;
            A.toast('Saved.');
            t.resolve();
          }
        });
      }
    },

    resolve() {
      let t = this;
      t.tapGridItem(t.gridItem);
    },

    goContact() {
      A.err('この機能は現在ご利用いただけません。');
    },

    viewForm() {
      this.boxName = 'view-form';
    },

    onConfirmDateRange(dates) {
      let t = this;
      const [start, end] = dates;
      t.currentDate = start;
      t.startDate = start;
      t.endDate = end;
      t.days = getDaysDiff(start, end);
      t.showDateRangePopover = false;
      t.disposed = true;

      let todayText = t.today.format("MM/dd");

      t.monthGrid = {};

      for (let i = 1; i <= t.days; i++) {
        let d = new Date(t.startDate.format("yyyy/MM/dd"));

        d.setDate(d.getDate() + i - 1);

        let date = d.format("MM/dd");

        t.monthGrid[date] = {
          k: 0,
          s: 0,
          suffix: ["日", "月", "火", "水", "木", "金", "土"][d.getDay()],
          is_today: date == todayText,
          day_index: d.getDay(),
          is_past: t.today > d
        };
      }

      t.loadData();
    },

    openDateRange(item) {
      this.defaultDates[0] = new Date(this.startDate.format('yyyy/MM/dd'));
      this.defaultDates[1] = new Date(this.endDate.format('yyyy/MM/dd'));
      this.showDateRangePopover = true;
    }

  },
  data() {
    return {
      showOrdersBox: false,
      defaultDates: [null, null],
      showDateRangePopover: false,
      emptyRoomMode: false,
      cleanTaskId: null,
      gridItem: null,
      disposed: false,
      tableScale: 100,
      showCalendar: false,
      minDate: new Date("2024/01/01"),
      currentDate: new Date(new Date().format("yyyy/MM/dd")),
      endDate: new Date(new Date().format("yyyy/MM/dd")),
      today: new Date(new Date().format("yyyy/MM/dd")),
      todayText: '',
      days: 31,
      selectedCleaner: null,
      selectedStatus: null,
      showDatePopover2: false,
      showGroupsEditor: false,
      showCleanersEditor: false,
      showCleanerEditor: false,
      showCleanerPopover: false,
      showStatusPopover: false,
      showWindow: false,
      //boxName: 'edit-order',
      //boxName: 'view-form',
      boxName: 'fill-form',
      month: 2,
      stats: {
        unfill_form: 0,
        today_unclean: 0,
        today_emergency_appointment: 0,
      },
      search: {
        tag: [],
        room_name: ''
      },
      list: {
        status: [
          { id: 1, text: "未開始" },
          { id: 2, text: "清掃中" },
          { id: 3, text: "完　了" },
        ],
        room: [],
        group: [],
        cleaner: [],
        selectedCleaner: [],
        selectedGroup: [],
        tag: [
          { id: 1, name: '京都', selected: false },
          { id: 2, name: '大阪', selected: false },
          { id: 3, name: '其他', selected: false },
        ],
      },
      dict: {
        group: {},
      },
      curGroup: null,
      curRoom: null,
      inited: false,
      monthGrid: {},
      roomGrid: {},
      checkInDict: {},
      checkOutDict: {},
      extraTaskDict: {},
      roomCheckInDict: {},
      statusDict: {},
      ksDict: {},
      ksTotal: { k: 0, s: 0, d: 0 },
      roomDict: {},
      cleanerDict: {},
      dateExtraDict: {},

      showFilter: false,
      filterName: '',

      keywordSearch: {
        tag_name: ''
      },

      toggle: {
        all: true,
        task: false,
        continuous: false,
        empty: false,
        checkin: false
      },

      fakeId: 0,


      orderForm: {},
      orderForm_o: {
        room_id: null,
        checkin_date: '',
        checkout_date: '',
        count_audlt: 1,
        count_child: 0,
        count_baby: 0,
        k: 1,
        s: 0,
        d: 0,
        max_k: 99,
        max_s: 99,
        max_d: 99
      },
    };
  },
  computed: {
    filteredRooms() {
      let t = this;
      let arr = [];

      let ids = [];

      t.fakeId;

      t.list.group.forEach((group) => {
        if (group.rooms) {
          group.rooms.forEach((room) => {
            ids.push(room.id);
          });
        }
      });

      t.list.room.forEach((room) => {
        if (ids.indexOf(room.id) < 0) {
          if (t.search.room_name && room.name.indexOf(t.search.room_name) < 0)
            return;
          arr.push(room);
        }
      });

      return arr;
    },

    filteredTags() {
      let t = this;

      let arr = [];

      t.list.tag.forEach(item => {
        if (t.keywordSearch.tag_name && (item.name.indexOf(t.keywordSearch.tag_name) > -1)) {
          arr.push(item);
        }
      });

      return arr;
    },

    selectedTags() {
      let t = this;

      let arr = [];

      t.list.tag.forEach(item => {
        if (item.selected) {
          arr.push(item);
        }
      });

      return arr;
    },
  },
};
